
export class LanguageCodes {
    public static FLASH_LANGUAGE_CODE_UNKNOWN: string = "xu";
}
